// extracted by mini-css-extract-plugin
export var statItem = "_e6-1";
export var statsRow = "_e6-0";